import httpClient from "../axiosBase/axiosHandler";
import { createHttpClient } from "../helpers";

const unAuthHttpClient = await createHttpClient();

export const createSubAccount = (payload) => {
  const response = httpClient.post("/business/", payload);
  return response;
};

export const getSubAccounts = () => {
  const response = httpClient.get("/business/");
  return response;
};

export const switchBusinessAccount = (payload) => {
  const response = httpClient.post("/business/switch-business/", payload);
  return response;
};

export const updateSubAccount = (payload) => {
  const response = httpClient.post("/business/update-sub-account/", payload);
  return response;
};

export const getCountries = () => {
  const response = httpClient.get("/locations/countries/");
  return response;
};

export const getCountry = (id) => {
  const response = httpClient.get(`/locations/countries/${id}/`);
  return response;
};

export const getStates = ({ id }) => {
  const response = httpClient.get(`/locations/${id}/get-state/`);
  return response;
};

export const getCities = ({ id }) => {
  const response = httpClient.get(`/locations/${id}/`);
  return response;
};

export const addCityToLocation = (payload) => {
  const response = httpClient.post("/locations/cities/", payload);
  return response;
};

export const getStoreLocations = (queryParams = {}) => {
  const response = httpClient.get(
    `/storefronts/${queryParams?.id}/business-storefront/`,
    {
      params: { ...queryParams },
    },
  );
  return response;
};

export const getCountriesForBusiness = (id) => {
  const response = httpClient.get(
    `/storefronts/${id}/business-store-locations/`,
  );
  return response;
};

export const getTimezones = () => {
  const response = httpClient.get("/timezones/");
  return response;
};

export const updateUserAccessCode = (id) => {
  const response = httpClient.post(`/profile/${id}/reset-access_code/`);
  return response;
};

export const updateReceiptCustomaizationData = (data) => {
  const response = httpClient.post("/business/update-business-profile/", data);
  return response;
};

export const consentToSupplierContact = (data) => {
  const response = httpClient.patch("/business-referral/consent/", data);
  return response;
};

export const getBusinessPotentialReward = () => {
  const response = httpClient.get("/business-referral/potential-reward/");
  return response;
};

export const getBusinessSupplierDetails = (queries = "") => {
  const response = unAuthHttpClient.get(
    `/business-referral/supplier-details/${queries}`,
  );

  return response;
};
